<div class="dtffleet">

<!-- <style>
  .mat-grid-tile {
  border-top: solid 2px darkblue;
  margin-top: 10px;
  margin-bottom: 10px;
  border: solid 1px black;
}
#work{
  background-color: #F3EA99;
}
</style> -->

<mat-grid-list cols="11" style="margin-top: 10px;" [gutterSize]="'10px'">
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="4"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Report Library</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <mat-list
              style="padding: 0px !important; padding-bottom: 5px !important;"
              role="list"
              *ngFor="let report of reports; let i = index"
            >
              <div style="display:flex;">
                <mat-list-item style="font-size:10px;" role="listitem"
                  >{{ report }}
                </mat-list-item>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item>
                    <mat-icon>dialpad</mat-icon>
                    <span>Redial</span>
                  </button>
                  <button mat-menu-item disabled>
                    <mat-icon>voicemail</mat-icon>
                    <span>Check voice mail</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>notifications_off</mat-icon>
                    <span>Disable alerts</span>
                  </button>
                </mat-menu>
              </div>
              <mat-divider></mat-divider>
            </mat-list>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- <mat-expansion-panel [expanded]="true" style="width:100%;">
        <mat-expansion-panel-header
          [collapsedHeight]="customCollapsedHeight"
          [expandedHeight]="customExpandedHeight"
        >
          <mat-panel-title> Report Library </mat-panel-title>
          <mat-panel-description> Recently Added </mat-panel-description>
        </mat-expansion-panel-header>
    

      <mat-action-row>
        <button mat-button color="primary" (click)="nextStep()">Next</button>
      </mat-action-row>
      </mat-expansion-panel> -->
  </mat-grid-tile>
  <mat-grid-tile
    style="overflow:auto"
    [colspan]="5"
    [rowspan]="3"
      >
    <mat-accordion
      class="example-headers-align"
      style="width: 100%; height: 100%;"
      multi="true"
    >
      <mat-expansion-panel
        [expanded]="true"
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Fleet Services</b>
        </mat-expansion-panel-header>
          <mat-accordion class="example-headers-align" multi="false">
            <div style="display:flex; gap:10px;">
              <label>Customer:</label>
              <select name="cars" id="cars">
                <option value="volvo">All</option>
                <option value="saab">One</option>
                <option value="opel">Two</option>
              </select>
              <label> Agreements:</label>
              <select name="cars" id="cars">
                <option value="volvo">All</option>
                <option value="saab">One</option>
                <option value="opel">Two</option>
              </select>
              <label> Assets:</label>
              <select name="cars" id="cars">
                <option value="volvo">All</option>
                <option value="saab">One</option>
                <option value="opel">Two</option>
              </select>
            </div>
            <mat-list role="list" *ngFor="let fleet of fleets; let i = index">
              <mat-list-item  style="font-size:10px;"  id="fleetlist" role="listitem"
                >{{ fleet }}
              </mat-list-item>
              <mat-divider></mat-divider>
            </mat-list>
          </mat-accordion>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- <mat-accordion>
      <mat-expansion-panel [expanded]="true" style="width:100%">
        <mat-expansion-panel-header
          [collapsedHeight]="customCollapsedHeight"
          [expandedHeight]="customExpandedHeight"
        >
          <mat-panel-title> Fleet Services</mat-panel-title>

        </mat-expansion-panel-header>
        <p>This is the content text that makes sense here.</p>
      </mat-expansion-panel>
    </mat-accordion> -->
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="1"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Alerts</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <div style="display:flex;">
              <span>Title Documents not recieved</span>
            </div>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="2"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Insurance</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <mat-list
              style="padding: 0px !important; padding-bottom: 5px !important;"
              role="list"
              *ngFor="let report of insurance; let i = index"
            >
              <div style="display:flex;">
                <mat-list-item style="font-size:10px;" role="listitem"
                  >{{ report }}
                </mat-list-item>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item>
                    <mat-icon>dialpad</mat-icon>
                    <span>Redial</span>
                  </button>
                  <button mat-menu-item disabled>
                    <mat-icon>voicemail</mat-icon>
                    <span>Check voice mail</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>notifications_off</mat-icon>
                    <span>Disable alerts</span>
                  </button>
                </mat-menu>
              </div>
              <mat-divider></mat-divider>
            </mat-list>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <mat-grid-tile
    style="overflow:auto"
    [colspan]="5"
    [rowspan]="1"
      >
    <mat-accordion
      class="example-headers-align"
      style="width: 100%; height: 100%;"
      multi="true"
    >
      <mat-expansion-panel
        [expanded]="true"
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Credit and Funding</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion class="example-headers-align" multi="false">
            <div style="display:flex; gap:10px;">
              <span style="font-size:10px;">Application Status</span>
              <span style="font-size:10px;"> Funding Status:</span>
              <span style="font-size:10px;"> Lines of Credit:</span>
              <span style="font-size:10px;">Title Status:</span>
            </div>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- <mat-accordion>
    <mat-expansion-panel [expanded]="true" style="width:100%">
      <mat-expansion-panel-header
        [collapsedHeight]="customCollapsedHeight"
        [expandedHeight]="customExpandedHeight"
      >
        <mat-panel-title> Fleet Services</mat-panel-title>

      </mat-expansion-panel-header>
      <p>This is the content text that makes sense here.</p>
    </mat-expansion-panel>
  </mat-accordion> -->
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="3"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Request Status:</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <span style="font-size:10px;"
            >000123- Payoff letter Request: In Progress</span
          ><br />
          <span style="font-size:10px;"
            >21034 - Tax Exemption approval: pending review</span
          ><br />
          <span style="font-size:10px;">54802 -Title copies: completed</span
          ><br />
          <h4>Coverages - All</h4>
          <mat-divider></mat-divider>
          <mat-card
            appearance="outlined"
            style="background-color: lightgray;  border-left: solid 2px green; padding-top:0px !important;"
          >
            <mat-card-header>
              <mat-card-title-group> </mat-card-title-group>
            </mat-card-header>
            <mat-card-content>
              <mat-accordion multi="false">
                <mat-list
                  style="padding: 0px !important; padding-bottom: 5px !important;"
                  role="list"
                >
                  <div style="display:flex;">
                    <mat-list-item  style="font-size:10px;"  role="listitem"
                      ><a
                        href="javascript:void(0)"
                        style="font-size:12px;padding: 0px !important"
                        >Limited Warranty on Remanufactured</a
                      >
                    </mat-list-item>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item>
                        <mat-icon>dialpad</mat-icon>
                        <span>Redial</span>
                      </button>
                      <button mat-menu-item disabled>
                        <mat-icon>voicemail</mat-icon>
                        <span>Check voice mail</span>
                      </button>
                      <button mat-menu-item>
                        <mat-icon>notifications_off</mat-icon>
                        <span>Disable alerts</span>
                      </button>
                    </mat-menu>
                  </div>
                  <mat-divider></mat-divider>
                  <span><b>ALL01</b></span
                  ><br />
                  <div style="display: flex; gap:10px">
                    <span style="font-size:10px;">Rel: 12/07/2020</span>
                    <span style="font-size:10px;">Rev: 06/26/2023</span>
                  </div>
                </mat-list>
              </mat-accordion>
            </mat-card-content>
          </mat-card>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="1"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Lease Maturities and Remarketing</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <div style="display:flex;">
              <span>Title Documents not recieved</span>
            </div>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <mat-grid-tile
    style="overflow:auto"
    [colspan]="5"
    [rowspan]="3"
      >
    <mat-accordion
      class="example-headers-align"
      style="width: 100%; height: 100%;"
      multi="true"
    >
      <mat-expansion-panel
        [expanded]="true"
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Sales and Marketing</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion class="example-headers-align" multi="false">
            <img
              src="static/assets/img/dtf-assets/images/redesign/DTF_Insurance_Carousel.png"
              style="background: top left no-repeat; background-size: cover; height:100%; width: 100%;"
            />
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- <mat-accordion>
<mat-expansion-panel [expanded]="true" style="width:100%">
  <mat-expansion-panel-header
    [collapsedHeight]="customCollapsedHeight"
    [expandedHeight]="customExpandedHeight"
  >
    <mat-panel-title> Fleet Services</mat-panel-title>

  </mat-expansion-panel-header>
  <p>This is the content text that makes sense here.</p>
</mat-expansion-panel>
</mat-accordion> -->
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="2"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Resource Library: Recently Added</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <mat-list
              style="padding: 0px !important; padding-bottom: 5px !important;"
              role="list"
              *ngFor="let resource of resources; let i = index"
            >
              <div style="display:flex;">
                <mat-list-item style="font-size:10px;" role="listitem"
                  >{{ resource }}
                </mat-list-item>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item>
                    <mat-icon>dialpad</mat-icon>
                    <span>Redial</span>
                  </button>
                  <button mat-menu-item disabled>
                    <mat-icon>voicemail</mat-icon>
                    <span>Check voice mail</span>
                  </button>
                  <button mat-menu-item>
                    <mat-icon>notifications_off</mat-icon>
                    <span>Disable alerts</span>
                  </button>
                </mat-menu>
              </div>
              <mat-divider></mat-divider>
            </mat-list>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <mat-grid-tile
    [colspan]="3"
    [rowspan]="2"
        style="overflow: auto"
  >
    <mat-accordion multi="true" style="width: 100%; height: 100%;">
      <mat-expansion-panel
        style="display: flex-wrap; overflow:auto; width: 100; height: 100%"
        [expanded]="true"
        showToggle="true"
      >
        <mat-expansion-panel-header>
          <b>Sales, Demo & Finance Programs</b>
        </mat-expansion-panel-header>
        <!-- use template to force lazy rendering -->
        <ng-template matExpansionPanelContent>
          <mat-accordion multi="false">
            <div style="display:flex; gap:10px;">
              <label>Type:</label>
              <select name="cars" id="cars">
                <option value="volvo">All</option>
                <option value="saab">One</option>
                <option value="opel">Two</option>
              </select>
            </div>
          </mat-accordion>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-grid-tile>
  <!-- Copyright 2024 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->
</mat-grid-list>
  
</div>